export const BLACK = "#000000";
export const WHITE = "#FFFFFF";
export const GREY__WHITE = "#F2F3F4";
export const GREY__DARK = "#BBB";
export const GREY__LINK = "#777";



// WEBPACK FOOTER //
// ./src/theme/colors.js